import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { adminLogin } from '../services/api';
import { FiLock, FiUser, FiArrowRight } from 'react-icons/fi';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/console/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Don't store credentials until we know they're valid
      const res = await adminLogin(username, password);
      if (res.data.success) {
        // Only store credentials after successful login
        localStorage.setItem('adminCredentials', JSON.stringify({ username, password }));
        login(username, password, res.data.data);
        navigate('/console/dashboard', { replace: true });
      } else {
        setError(res.data.message);
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <img src="/logo.png" alt="Lancer" />
        <h2>Welcome Back</h2>
        <p>Sign in to LANCER Loyalty Console</p>

        {error && <div className="login-error">{error}</div>}

        <div style={{ position: 'relative' }}>
          <FiUser style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.3)', fontSize: 16, pointerEvents: 'none' }} />
          <input
            className="form-control"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={{ paddingLeft: 44 }}
          />
        </div>
        <div style={{ position: 'relative' }}>
          <FiLock style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.3)', fontSize: 16, pointerEvents: 'none' }} />
          <input
            className="form-control"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ paddingLeft: 44 }}
          />
        </div>
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.6s linear infinite', display: 'inline-block' }}></span>
              Signing in...
            </span>
          ) : (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              Sign In <FiArrowRight />
            </span>
          )}
        </button>
        <div className="login-footer">Sail Abrasive Pvt Ltd &copy; {new Date().getFullYear()}</div>
      </form>
    </div>
  );
};

export default LoginPage;
